import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { Provider } from 'react-redux';
import { store } from './store';
import * as Sentry from "@sentry/react";

// Initialize Sentry (only in production to avoid development noise)
const isDevelopment = () => {
  const nodeEnv = typeof process !== 'undefined' && process.env ? process.env.NODE_ENV : '';
  return nodeEnv === 'development' || 
         window.location.hostname === 'localhost' ||
         window.location.hostname === '127.0.0.1' ||
         window.location.hostname.includes('.local');
};

if (!isDevelopment()) {
  const nodeEnv = typeof process !== 'undefined' && process.env ? process.env.NODE_ENV : 'production';
  
  Sentry.init({
    dsn: "https://348cf95c69c52cf79bca8a24ec283611@o4509737034579968.ingest.us.sentry.io/4509737035759616",
    environment: nodeEnv,
    // Setting this option to true will send default PII data to Sentry.
    sendDefaultPii: true,
    // Logs
    enableLogs: true,
    // Sample rate for performance monitoring
    tracesSampleRate: 1.0,
    // Sample rate for session replay
    replaysSessionSampleRate: 0.1,
    // Sample rate for session replay on errors
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.replayIntegration(),
    ],
  });
} else {
  console.log('🔍 Sentry disabled in development environment');
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <Sentry.ErrorBoundary 
        fallback={({ error }) => {
          // Log error in development
          if (isDevelopment()) {
            console.error('Sentry Error Boundary triggered:', error);
          }
          
          // Redirect to the existing GeneralError page
          setTimeout(() => {
            window.location.href = '/error';
          }, 100);
          
          // Show minimal loading state while redirecting
          return <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '100vh',
            fontFamily: 'system-ui, sans-serif',
            color: '#666'
          }}>
            Redirigiendo...
          </div>;
        }}
      >
        <App />
      </Sentry.ErrorBoundary>
    </Provider>
  </StrictMode>,
)
